import axios from "axios";
import { history } from "../helpers";

export const axiosInstance = axios.create({
  headers: {},
});

export const logout = () => {
  axiosInstance.defaults.headers.common["Authorization"] = "";
  localStorage.clear();
  history.push("/");
  window.location.reload(true);
};

export const colors = [
  // "#00A76F" /* Green  */,
  "#FF5630" /* Orange */,
  "#FFAB00" /* Yellow */,
  "#00B8D9" /* Blue   */,
  "#8E33FF" /* Purple */,
  "#E94848" /* Red    */,
  "#F08080",
  "#556B2F",
  "#8A2BE2",
  "#191970",
  "#DEB887",
];
